<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        @if (!orderTaxShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="orderTaxes" formControlName="orderTaxId" (onChange)="setOrderTaxId($event)" optionLabel="name" appendTo="body"
              optionValue="orderTaxId" placeholder="Order Tax" [filter]="true" filterBy="name" [showClear]="false"></p-dropdown>
              <label for="orderTaxId">Order Tax</label>
              @for (validation of validationMessages.orderTaxId; track validation) {
                <span>
                  @if (form1.get('orderTaxId').hasError(validation.type) && (form1.get('orderTaxId').dirty || form1.get('orderTaxId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        @if (orderTaxShortTermRentalFlag) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="orderTaxes" formControlName="orderTaxId" (onChange)="setOrderTaxId($event)" optionLabel="name" appendTo="body"
              optionValue="orderTaxId" placeholder="Order Tax" [filter]="true" filterBy="name" [showClear]="false" readonly="true"></p-dropdown>
              <label for="orderTaxId">Order Tax</label>
              @for (validation of validationMessages.orderTaxId; track validation) {
                <span>
                  @if (form1.get('orderTaxId').hasError(validation.type) && (form1.get('orderTaxId').dirty || form1.get('orderTaxId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        <!-- <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="orderTaxes" formControlName="orderTaxId" optionLabel="name"
          optionValue="orderTaxId" placeholder="Order Tax"></p-dropdown>
          <label for="orderTaxId">Order Tax</label>
          <span *ngFor="let validation of validationMessages.orderTaxId">
            <small class="p-invalid"
              *ngIf="form1.get('orderTaxId').hasError(validation.type) && (form1.get('orderTaxId').dirty || form1.get('orderTaxId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <!-- <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
        optionValue="shortTermRentalId" placeholder="Properties"></p-dropdown>
        <label for="shortTermRentalId">Properties</label>
        <span *ngFor="let validation of validationMessages.shortTermRentalId">
          <small class="p-invalid"
            *ngIf="form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->

    <h5>Properties</h5>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown class="w-100" [options]="filters" (onChange)="selectedFilters($event)" [(ngModel)]="selectedFilter" optionLabel="name"
        optionValue="value" placeholder=""></p-dropdown>
        <label for="selectedFilter">Select Filter</label>
      </span>
    </div>

    @if (isDataLoaded) {
      <p-pickList #pickList [source]="sourceProperties" [target]="targetProperties" sourceHeader="Available ({{sourceProperties.length}})" targetHeader="Selected ({{targetProperties.length}})"
        [dragdrop]="true" [responsive]="true" [sourceStyle]="{ height: '30rem' }" [targetStyle]="{ height: '30rem' }"
        filterBy="{{selectedFilter}}" sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name"
        breakpoint="1400px" (onMoveAllToSource)="moveAllToSource($event)" (onMoveAllToTarget)="moveAllToTarget($event)" (onMoveToTarget)="moveToTarget($event)" (onMoveToSource)="moveToSource($event)">
        <ng-template let-property pTemplate="item">
          <div class="flex flex-wrap p-2 align-items-center gap-3">
            <div class="flex-1 flex flex-column gap-2">
              <span class="font-bold">
                {{ property?.propertyCode }} ({{property?.bedroomNum}} {{property?.adrCity}} {{property?.adrState}} {{property?.adrCounty}})
              </span>
              <!-- <div class="flex align-products-center gap-2">
              <span>
                {{ property?.adrCity }}
              </span>
            </div> -->
          </div>
          <!-- <span class="font-bold text-900">
          {{ '$' + product.price }}
        </span> -->
      </div>
    </ng-template>
  </p-pickList>
}


</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          <!-- <button pButton *ngIf="orderTaxShortTermRentalFlag" class="btn-delete p-button-outlined p-button-danger"
        (click)="onFormDelete()">Delete</button> -->
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        <!-- <button pButton *ngIf="!orderTaxShortTermRentalFlag" class="btn-addt p-button" (click)="formAdd()">Add</button>

        <button pButton *ngIf="orderTaxShortTermRentalFlag"  class="btn-upt p-button" (click)="formUpdate()">Update</button> -->
      </div>
    </div>
  </div>
</div>
</div>